import { Input } from "@chakra-ui/react";

interface TextFilterProps {
  id: string;
  onFilterChange: (event: any) => void;
}

export const SimpleTextFilter = ({ id, onFilterChange }: TextFilterProps) => {
  const handleChange = (event: any) => {
    console.log(event);

    return onFilterChange(event);
  };
  return (
    <Input
      mt="15px"
      placeholder="Filter"
      id={id}
      border="1px solid rgba(0, 0, 0, 0.14) !important"
      onChange={handleChange}
    />
  );
};
